import React, { useEffect, useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/master/user/Datatables";
import ModalForm from "component/master/user/ModalForm";

function User() {
  const [modalMode, setModalMode] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState([]);

  const fetchUser = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/user`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data user");
  
      const data = await response.json();
      setUser(data.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | User";
      window.scrollTo(0, 0);
      fetchUser();
  }, []);


  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setIsModalOpen(true);
  }

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setIsModalOpen(true);
  }

  const handleDeleteUser = async (user) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus User',
        text: `Apakah Anda yakin ingin menghapus user ${user.name}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      const response = await axios.delete(
        `${process.env.REACT_APP_API}/user/${user.username}`
      );
  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "User berhasil dihapus");
        fetchUser();
      } else {
        showError(response.data.message || "Gagal menghapus user");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus user");
    }
  };  
    

  const closeModal = () => {
    setIsModalOpen(false);
  }
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">User Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleAddUser}>
                              </i>
                            </div>
                            <Datatables data={user} onEditUser={handleEditUser} onDeleteUser={handleDeleteUser}/>
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

      {isModalOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <ModalForm mode={modalMode} userData={selectedUser} closeModal={closeModal} onSuccess={fetchUser}/>
        </div>
      )}

    </div>
  );
}

export default User;
